import { Collapse, IconButton, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IProductFeature } from 'services/api/entities';
import theme from 'theme';
import { ProductType } from 'services/api/entities/stripe/product';
import { IProductLicenseInfo } from 'services/api/entities/stripe/product/iProductLicenseInfo';
import LicenseInfoSection from '../LicenseInfoSection';
import DistributionSection from '../DistributionSection';
import FeaturesList from './FeaturesList';
import {
  StyledFeaturesContainer,
  StyledHiddenFeaturesContainer,
  StyledKeyboardArrowDownIcon,
  StyledKeyboardArrowUpIcon,
  StyledBox,
  StyledTypography,
} from './styled';

type FeaturesProps = {
  features: IProductFeature[];
  productType: ProductType;
  licenseInfo: IProductLicenseInfo;
};

const INITIAL_VISIBLE_FEATURES = 4;

const FeaturesSection = ({
  features,
  productType,
  licenseInfo,
}: FeaturesProps) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  if (isDesktop) {
    return (
      <StyledFeaturesContainer data-testid="price-features-section">
        <FeaturesList features={features} />
      </StyledFeaturesContainer>
    );
  }

  return (
    <>
      <StyledFeaturesContainer>
        <FeaturesList features={features.slice(0, INITIAL_VISIBLE_FEATURES)} />
      </StyledFeaturesContainer>

      {features.length > INITIAL_VISIBLE_FEATURES && (
        <>
          <StyledBox>
            <StyledTypography>
              {expanded
                ? t('subscription:pricing:hideAllFeatures')
                : t('subscription:pricing:showAllFeatures')}
            </StyledTypography>
            <IconButton onClick={handleToggle} size="small">
              {expanded ? (
                <StyledKeyboardArrowUpIcon />
              ) : (
                <StyledKeyboardArrowDownIcon />
              )}
            </IconButton>
          </StyledBox>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <StyledHiddenFeaturesContainer>
              <FeaturesList
                features={features.slice(INITIAL_VISIBLE_FEATURES)}
              />
            </StyledHiddenFeaturesContainer>
            <DistributionSection productType={productType} />
            <LicenseInfoSection
              title={licenseInfo.title}
              description={licenseInfo.description}
            />
          </Collapse>
        </>
      )}
    </>
  );
};

export default FeaturesSection;
